"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputBoxControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var label_1 = require("../controls/label");
var FileInputBoxControl = function (_a) {
    var _b, _c, _d;
    var file = _a.file, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.isReadOnly, isReadOnly = _f === void 0 ? false : _f, _g = _a.previewFile, previewFile = _g === void 0 ? false : _g, onChange = _a.onChange, onClear = _a.onClear, errorText = _a.errorText, required = _a.required, supportedFileTypes = _a.supportedFileTypes, imageUrl = _a.imageUrl, _h = _a.colors, colors = _h === void 0 ? {
        borderColor: "border-default",
        textColor: "text-gray-800",
        iconColor: "text-blue-500",
        errorTextColor: "text-red-600",
        placeholderColor: "text-gray-500",
    } : _h, ratios = _a.ratios, maxFileSize = _a.maxFileSize, className = _a.className;
    var _j = (0, react_3.useState)(file), selectedFile = _j[0], setSelectedFile = _j[1];
    var _k = (0, react_3.useState)(), filePreview = _k[0], setFilePreview = _k[1];
    var _l = (0, react_3.useState)(false), dragging = _l[0], setDragging = _l[1];
    var _m = (0, react_3.useState)(errorText), error = _m[0], setError = _m[1];
    var _o = (0, react_3.useState)(false), isLoadingImage = _o[0], setIsLoadingImage = _o[1];
    var _p = (0, react_3.useState)(false), imageLoaded = _p[0], setImageLoaded = _p[1];
    var fileInputRef = (0, react_3.useRef)(null);
    (0, react_3.useEffect)(function () {
        setSelectedFile(file);
        if (file && previewFile && file.type.startsWith("image/")) {
            setIsLoadingImage(true);
            var reader_1 = new FileReader();
            reader_1.onloadend = function () {
                setFilePreview(reader_1.result);
                setIsLoadingImage(false);
            };
            reader_1.readAsDataURL(file);
        }
        else {
            setFilePreview(undefined);
            setIsLoadingImage(false);
        }
    }, [file, previewFile]);
    (0, react_3.useEffect)(function () {
        setError(errorText);
    }, [errorText]);
    (0, react_3.useEffect)(function () {
        if (imageUrl && previewFile) {
            setImageLoaded(false);
        }
    }, [imageUrl, previewFile]);
    var validateImageDimensions = function (file) {
        if (!(ratios === null || ratios === void 0 ? void 0 : ratios.width) || !(ratios === null || ratios === void 0 ? void 0 : ratios.height)) {
            return Promise.resolve(true);
        }
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                if (img.width <= ratios.width && img.height <= ratios.height) {
                    resolve(true);
                }
                else {
                    setError("Image dimensions must be less than or equal to ".concat(ratios.width, "x").concat(ratios.height));
                    resolve(false);
                }
            };
            img.onerror = function () {
                setError("Invalid image file");
                resolve(false);
            };
            img.src = URL.createObjectURL(file);
        });
    };
    var handleFileChange = function (newFile) { return __awaiter(void 0, void 0, void 0, function () {
        var maxSizeMB, isValid, reader_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(undefined); // Clear any previous errors
                    // Validate file size
                    if (maxFileSize && newFile.size > maxFileSize) {
                        maxSizeMB = (maxFileSize / (1024 * 1024)).toFixed(0);
                        setError("File size must be less than ".concat(maxSizeMB, "MB"));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, validateImageDimensions(newFile)];
                case 1:
                    isValid = _a.sent();
                    if (isValid) {
                        setSelectedFile(newFile);
                        onChange(newFile);
                        if (previewFile && newFile.type.startsWith("image/")) {
                            reader_2 = new FileReader();
                            reader_2.onloadend = function () { return setFilePreview(reader_2.result); };
                            reader_2.readAsDataURL(newFile);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDragOver = function (event) {
        if (disabled || isReadOnly)
            return;
        event.preventDefault();
        setDragging(true);
    };
    var handleDragLeave = function (event) {
        if (disabled || isReadOnly)
            return;
        event.preventDefault();
        setDragging(false);
    };
    var handleDrop = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var newFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disabled || isReadOnly)
                        return [2 /*return*/];
                    event.preventDefault();
                    setDragging(false);
                    if (!(event.dataTransfer.files && event.dataTransfer.files.length > 0)) return [3 /*break*/, 2];
                    newFile = event.dataTransfer.files[0];
                    return [4 /*yield*/, handleFileChange(newFile)];
                case 1:
                    _a.sent();
                    event.dataTransfer.clearData();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleBrowseChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var newFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.target.files && event.target.files.length > 0)) return [3 /*break*/, 2];
                    newFile = event.target.files[0];
                    return [4 /*yield*/, handleFileChange(newFile)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleClear = function () {
        setSelectedFile(undefined);
        setFilePreview(undefined);
        if (onClear)
            onClear();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsxs)("div", { className: "relative flex items-center justify-center h-[180px] p-4 border-2 border-dashed overflow-hidden ".concat(dragging ? "border-accent" : (_b = colors.borderColor) !== null && _b !== void 0 ? _b : "border-default", " rounded-lg ").concat(colors.backgroundColor, " ").concat(disabled ? "opacity-50 cursor-not-allowed" : "", " ").concat(className), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, children: [selectedFile && !disabled && !isReadOnly && ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, className: "absolute top-2 right-2 z-10 min-w-8 w-8 h-8 rounded-full", size: "sm", onPress: handleClear, variant: "tertiary", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-linear", className: "text-sm" }) })), selectedFile || imageUrl ? (previewFile && (filePreview || imageUrl) ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-1 w-full overflow-hidden relative", children: [(isLoadingImage || (imageUrl && !imageLoaded && !filePreview)) && ((0, jsx_runtime_1.jsxs)("div", { className: "absolute inset-0 flex flex-col items-center justify-center gap-2 bg-white/80 z-10", children: [(0, jsx_runtime_1.jsx)(react_1.Spinner, {}), (0, jsx_runtime_1.jsx)(label_1.Label, { label: (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) || (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.split("/").pop()) || "Loading...", className: "text-wrap break-all text-xs max-w-full px-2 line-clamp-2" })] })), (0, jsx_runtime_1.jsx)("img", { src: filePreview || imageUrl, alt: "Preview", className: "max-w-full max-h-32 object-contain rounded flex-shrink-0", onLoad: function () {
                                    setIsLoadingImage(false);
                                    setImageLoaded(true);
                                } }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) || (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.split("/").pop()) || "", className: "text-wrap break-all text-xs max-w-full px-2 line-clamp-2" })] })) : ((0, jsx_runtime_1.jsx)(label_1.Label, { label: (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) || (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.split("/").pop()) || "", className: "text-wrap break-all px-4 line-clamp-3" }))) : isReadOnly ? ((0, jsx_runtime_1.jsx)(label_1.Label, { label: "No file", textColor: "text-gray-500" })) : ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2 items-center", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:cloud-upload-linear", width: 48, className: "".concat((_c = colors.iconColor) !== null && _c !== void 0 ? _c : "text-blue-500") }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row justify-center items-center gap-2", children: [required && (0, jsx_runtime_1.jsx)(label_1.Label, { label: "*", textColor: "text-red-600" }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Drop file or" }), (0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "primary", className: "flex items-center", isDisabled: disabled || isReadOnly, size: "sm", onPress: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: [(0, jsx_runtime_1.jsx)("input", { ref: fileInputRef, type: "file", hidden: true, onChange: handleBrowseChange, accept: supportedFileTypes === null || supportedFileTypes === void 0 ? void 0 : supportedFileTypes.join(","), disabled: disabled || isReadOnly }), "Browse"] })] }), (supportedFileTypes === null || supportedFileTypes === void 0 ? void 0 : supportedFileTypes.length) && ((0, jsx_runtime_1.jsx)(label_1.Label, { label: "Supported file types: ".concat(supportedFileTypes.join(" ")), size: "small", textColor: "text-gray-500", className: "text-wrap text-center" })), ratios && (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Max Pixels: ".concat(ratios.height, "x").concat(ratios.width), size: "small", textColor: "text-gray-500", className: "text-center" }), maxFileSize && (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Max File Size: ".concat((maxFileSize / (1024 * 1024)).toFixed(0), "MB"), size: "small", textColor: "text-gray-500", className: "text-center" })] }))] }), error && (0, jsx_runtime_1.jsx)(label_1.Label, { label: error, textColor: (_d = colors.errorTextColor) !== null && _d !== void 0 ? _d : "text-red-600", size: "xsmall", className: "text-wrap px-1" })] }));
};
exports.FileInputBoxControl = FileInputBoxControl;
